module.exports = __webpack_public_path__ + "static/media/club-logo.e11f36c4.svg";